import * as React from 'react';
import { useQuery } from '@apollo/react-hooks';
import { AppInstallationListView } from './view';
import { APP_INSTALLATION_LIST_QUERY } from 'const/queries';
import CircularProgress from '@material-ui/core/CircularProgress';
import { useParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { Button, Container } from '@material-ui/core';
import { AppInstallationEdge, PageInfo } from '../../../types/generated';

export const AppInstallationList = () => {
    const { id: appId } = useParams<{ id: string }>();
    const [pageInfo, setPageInfo] = useState<PageInfo>();
    const [cursor, setCursor] = useState<string | undefined>();
    const [edges, setEdges] = useState<AppInstallationEdge[] | undefined[]>([]);

    const query = {
        after: cursor,
        appId: appId,
        first: 10,
    };
    const { data, refetch } = useQuery(APP_INSTALLATION_LIST_QUERY, {
        variables: query,
        onCompleted: d => {
            const { pageInfo: pInfo } = d.installations;
            if (pInfo) {
                setPageInfo(pInfo);
            }

            if (d.installations?.edges?.length > 0) {
                const newEdges = d.installations.edges;
                setEdges([...edges, ...newEdges]);
            }
        },
    });

    useEffect(() => {
        (async () => {
            const res = await refetch(query);

            if (res.data.installations.edges) {
                setEdges(res.data.installations.edges);
            }
        })();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    if (data) {
        return (
            <>
                <AppInstallationListView appId={appId} list={data && edges} />
                {pageInfo?.hasNextPage && pageInfo?.endCursor && (
                    <Container
                        maxWidth={'md'}
                        style={{ display: 'flex', justifyContent: 'center', paddingTop: 24 }}
                    >
                        <Button onClick={() => setCursor(pageInfo.endCursor)}>Load more</Button>
                    </Container>
                )}
            </>
        );
    } else {
        return <CircularProgress />;
    }
};
